// Defined by vite.config.ts; vitest does not load that config, hence the guard.
export const APP_VERSION: string = typeof __APP_VERSION__ === 'string' ? __APP_VERSION__ : 'dev'
